import { MatchQuality } from '@upright/common/model/search/match-quality';

/**
 * Banner text for a given match-confidence verdict, or `null` when no banner is
 * warranted. Two distinct warnings, because the two failure modes need
 * different guidance:
 *
 * - `low-confidence` — the top hit is weak overall (a fuzzy match with nothing
 *   strong behind it). Nudge the user to look harder or refine the query.
 * - `ambiguous` — two similarly-strong hits the tie-breakers cannot separate
 *   (e.g. Helen Oy in Finland vs Helen Of Troy in the US). Here the results ARE
 *   relevant; the risk is picking the wrong same-named entity, so point the user
 *   at the country / listing metadata shown on each row.
 *
 * `confident` / `undefined` produce no banner. Pure (no JSX) so it lives in a
 * `.ts` module and the message selection can be unit-tested directly.
 */
export function matchConfidenceBannerMessage(matchQuality: MatchQuality | undefined): string | null {
  switch (matchQuality) {
    case 'low-confidence':
      return 'No confident match — check the results carefully or refine your search.';
    case 'ambiguous':
      return 'Several companies match this name — check the country and listing status before selecting.';
    case 'confident':
    case undefined:
      return null;
  }
}
